import React from 'react';

const SvgLeftCarrot = (props) => (
  <svg width={24} height={24} viewBox="0 0 24 24" {...props}>
    <path d="M7.8 12l6.3-6.235v12.47L7.8 12z" />
  </svg>
);

export default SvgLeftCarrot;
